import React from 'react';
import cn from 'classnames';

import { STATUS_ICON, STATUS_TEXT } from 'constants/common';

import { idxMap } from 'helpers/styleMapIdx';

import { Icon } from 'components/shared/Icon';
import { Typography } from 'components/shared/Typography';

import styles from './PublishStatusTag.module.scss';

const STATUS_VARIANTS = {
  draft: styles.draft,
  published: styles.published,
  archived: styles.archived,
};

const PublishStatusTag = ({
  className,
  variant,
}: {
  className: any;
  variant: any;
}) => (
  <div
    className={cn(
      styles.tag,
      idxMap(STATUS_VARIANTS as Record<string, string>, variant),
      className,
    )}
  >
    <Icon
      className={styles.icon}
      name={idxMap(STATUS_ICON as Record<string, string>, variant)}
    />
    <Typography
      className={styles.text}
      variant="body3"
      weight="medium"
      mode="compact"
    >
      {idxMap(STATUS_TEXT as Record<string, string>, variant)}
    </Typography>
  </div>
);

export default React.memo(PublishStatusTag) as any;
